import { render, staticRenderFns } from "./SocialsGroup.vue?vue&type=template&id=10ce2f88&"
import script from "./SocialsGroup.vue?vue&type=script&lang=js&"
export * from "./SocialsGroup.vue?vue&type=script&lang=js&"
import style0 from "./SocialsGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports